import React, { useEffect, useState } from 'react';
import Modal from "react-bootstrap/Modal";
import { CloseIcon } from '../assets/Icons';
import Select from "react-select";
import apiClient from '../apiClient';
import { SSO_URL } from '../env';
import { FETCH_ENUM_TYPES, CREATE_DEFAULT_CONFIGURATION } from '../apiClient/apiEndpoints';

const templateTypeOptions = [
    {
        label: "Application",
        value: "APPLICATION",
    },
    {
        label: "Channel",
        value: "CHANNEL",
    },
];

const selectTheme = (theme) => ({
    ...theme,
    borderRadius: 5,
    colors: {
        ...theme.colors,
        primary50: "#ca373c50",
        primary25: "#ca373c50",
        primary: "#ca373c70",
        danger: "#000000",
        neutral30: "#00000050",
    },
});

const AddConfigurationMethod = ({ applicationId, openModal, setOpenModal }) => {
    const [templateType, setTemplateType] = useState(null);
    const [loading, setLoading] = useState(false); 
    const [configurationType, setConfigurationType] = useState(null);
    const [configNameOptions, setConfigNameOptions] = useState([]);
    const [configurationKeys, setConfigurationKeys] = useState([]);

    const handleCloseModal = () => {
         setTemplateType (null);
         setConfigurationType(null);
        setOpenModal(false);
    }
    const handleSaveDetails = async() => {
        if(loading) return;
          try {
            setLoading(true);
            const payload = {
                data: {},
                name: configurationType.value,
                templateType: templateType.value,
              }
              await apiClient.post(`${SSO_URL}${CREATE_DEFAULT_CONFIGURATION}/${applicationId}`, payload);
        } catch (error) {
            console.log(error);
        }finally{
              setLoading(false);
          }
    }

    const fetchConfigurationTypes = async () => {
        try {
            const res = await apiClient.get(`${SSO_URL}${FETCH_ENUM_TYPES}/configurationType`);
            const configOptions = Object.entries(res || {}).map(([key, value]) => ({ label: key, value: value }));
            setConfigurationKeys(configOptions);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchConfigurationTypes();
    }, []);

    useEffect(() => {
        setConfigurationType(null);
        if (templateType?.value === "APPLICATION") {
            setConfigNameOptions([{ label: "ENV", value: "ENV" }]);
        }else if (templateType?.value === "CHANNEL") {
            setConfigNameOptions(configurationKeys.filter((item) => item.value !== "ENV"));
        }else{
            setConfigNameOptions([]);
        }
    }, [templateType?.value]);

    return (
        <>
            <Modal show={openModal} size="md" centered onHide={() => handleCloseModal(false)}>
                <Modal.Header className="modalheader">
                    Add New Configuration
                    <span onClick={() => handleCloseModal(false)}>
                        <CloseIcon />
                    </span>
                </Modal.Header>

                <Modal.Body className="pb-0">
                    <div className="row">
                        <div className="col-12 standardinput mt-3">
                            <label className="mb-2">
                                Type <span>*</span>
                            </label>
                            <div className="forselect-input">
                                <Select
                                    theme={selectTheme}
                                    value={templateType}
                                    options={templateTypeOptions}
                                    onChange={(option) => setTemplateType(option)}
                                />
                            </div>
                        </div>

                        <div className="col-12 standardinput mt-3">
                            <div className="standardinput">
                                <label>Configuration Name</label>
                                <div className="forselect-input">
                                    <Select
                                        theme={selectTheme}
                                        value={configurationType}
                                        options={configNameOptions}
                                        onChange={(option) => setConfigurationType(option)}
                                    />
                                </div>
                            </div>
                        </div> 
                    </div>
                </Modal.Body>

                <Modal.Footer className="footerbtn mt-3">
                    <button className="cancel" onClick={() => handleCloseModal(false)}>
                        Cancel
                    </button>

                    <button className="save" onClick={handleSaveDetails}>
                        Save
                    </button>

                </Modal.Footer>
            </Modal>
        </>
    )
}

export default AddConfigurationMethod
